import React from 'react'
import AboutUs from './AboutUs/AboutUs'
import './home.css'
import ProgrammingLanguage from './ProgrammingLanguage/ProgrammingLanguage'

const Home = () => {
    return (
        <>
            <div className="mainHome">
                <div className="subHome">
                    <div className="Home">
                        <AboutUs />
                    </div>

                    <div className="Home">
                        <ProgrammingLanguage />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home